export default class FarklePlayer {
    recId = 0;

    name = 'Player Name';

    totalScore = 0;

    score = [];

    isWinning = false;

    isCloseToWinning = false;

    useScroll = false;

    calculateTotalScore() {
      let totScore = 0;
      let s = 0;
      if (this.score != null) {
        while (s < this.score.length) {
          if (this.score[s] !== '') {
            totScore += parseInt(this.score[s], 10);
          }
          s += 1;
        }
      }

      this.totalScore = totScore;
    }

    isPlayerWinning(winningScore) {
      this.isWinning = (this.totalScore >= winningScore);
      if (!this.isWinning && winningScore > 0 && this.totalScore > 0) {
        this.isCloseToWinning = (((this.totalScore / winningScore) * 100) >= 75);
      } else {
        this.isCloseToWinning = false;
      }
    }
}
